import { render, staticRenderFns } from "./DiffbotCategories.vue?vue&type=template&id=c2f71828&scoped=true"
import script from "./DiffbotCategories.vue?vue&type=script&lang=js"
export * from "./DiffbotCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f71828",
  null
  
)

export default component.exports